export default {
  root: { color: '#444444' },
  notchedOutline: {
    borderColor: 'rgba(0,0,0,0.15)'
  }
};
